import React, { useState, useEffect } from "react";
import { useTheme } from "@repo/shared";
import { useParams, useHistory } from "react-router-dom";
import StudentDataService from "../../services/student/StudentService";
import LoadingSpinner from '../common/LoadingSpinner';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { Container, Card, Button, Table, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import ParentDataService from "../../services/parent/ParentService";

const Parent = props => {
  const { appTheme } = useTheme();
  const { id } = useParams();
  const history = useHistory();
  const initialParentState = ParentDataService.initialiseNewParent();
  const [currentParent, setCurrentParent] = useState(initialParentState);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [updateMode, setUpdateMode] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [students, setStudents] = useState([]);
  const [studentsLoading, setStudentsLoading] = useState(false);

  const getParent = id => {
    ParentDataService.get(id)
      .then(response => {
        setCurrentParent(response);
        console.log(response);
        setLoading(false);
        // Fetch students for this parent
        getStudentsForParent(id);
      })
      .catch(e => {
        console.log(e);
        setLoading(false);
      });
  };

  const getStudentsForParent = id => {
    setStudentsLoading(true);
    StudentDataService.getStudentsForParent(id)
      .then(response => {
        setStudents(response || []);
        setStudentsLoading(false);
      })
      .catch(e => {
        console.log(e);
        setStudentsLoading(false);
      });
  };

  useEffect(() => {
    document.title = `${appTheme?.appName} - Parent`;
    if (id) {
      getParent(id);
      setUpdateMode(true);
    } else {
      setLoading(false);
    }
  }, [id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentParent({ ...currentParent, [name]: value });
  };

  const validate = () => {
    const errorFields = [];

    if (!currentParent.firstName) {
      errorFields.push('First Name');
    }
    if (!currentParent.lastName) {
      errorFields.push('Last Name');
    }
    if (!currentParent.email) {
      errorFields.push('Email Address');
    }

    if (errorFields.length) {
      setErrorMessage(`These fields may not be blank: ${errorFields.join(',')}`);
      return false;
    } else {
      setErrorMessage(null);
      return true;
    }
  };


  const addParent = () => {
    if (validate()) {
      setSaving(true);
      ParentDataService.create(currentParent)
        .then(response => {
          console.log(response);
          setMessage("The Parent was saved successfully!");
          setSaving(false);

          //Now that we have a parent, set that onto the path so that we switch into update mode
          history.push(`/parent/${response.id}`);
          //history.goBack();
        })
        .catch(e => {
          console.log(e);
          setSaving(false);
        });
    }
  };

  const updateParent = () => {
    if (validate()) {
      setSaving(true);
      ParentDataService.update(currentParent.id, currentParent)
        .then(response => {
          console.log(response);
          setMessage("The Parent was updated successfully!");
          setSaving(false);
          //history.goBack();
        })
        .catch(e => {
          console.log(e);
          setSaving(false);
        });
    }
  };

  const deleteParent = () => {
    confirmAlert({
      title: 'Delete Parent',
      message: `Are you sure you want to delete this parent?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            setSaving(true);
            ParentDataService.deleteParent(currentParent.id)
              .then(response => {
                console.log(response);
                setSaving(false);
                history.push("/parents");
              })
              .catch(e => {
                console.log(e);
                setSaving(false);
              });
          }
        },
        {
          label: 'No',
          onClick: () => { }
        },
      ]
    });

  };

  const openStudent = (studentId) => {
    history.push(`/student/${studentId}`);
  };

  const addStudent = () => {
    history.push(`/student?parentId=${currentParent.id}`);
  };

  const renderStudents = () => {

    return (
      <Card className="mt-4">
        <Card.Header>
          <h5 className="mb-0">Students for this parent</h5>

          <Button variant="primary" size="sm" onClick={addStudent} className="ms-auto" disabled={!currentParent?.id}>
            <FontAwesomeIcon icon={faPlus} className="me-2" />Add Student
          </Button>
        </Card.Header>
        <Card.Body className="p-0">
          {studentsLoading ? (
            <div className="p-4">
              <LoadingSpinner />
            </div>
          ) : students.length === 0 ? (
            <div className="p-4 text-muted">No students found</div>
          ) : (
            <Table hover className="mb-0">
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Class</th>
                  <th>Year</th>
                  <th>School</th>
                </tr>
              </thead>
              <tbody>
                {students.map(student => (
                  <tr
                    key={student.id}
                    onClick={() => openStudent(student.id)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>{student.firstName}</td>
                    <td>{student.lastName}</td>
                    <td>{student.className || '-'}</td>
                    <td>{student.year || '-'}</td>
                    <td>{student.school?.name || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>);
  };
  const renderBody = () => {
    return (
      <>
        <form>
          <div className="d-flex justify-content-between">
            <div className="form-group col-5" >
              <label htmlFor="title">First Name *</label>
              <input
                type="text"
                className="form-control"
                id="firstName"
                name="firstName"
                value={currentParent.firstName}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group col-5" >
              <label htmlFor="title">Last Name *</label>
              <input
                type="text"
                className="form-control"
                id="lastName"
                name="lastName"
                value={currentParent.lastName}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="description">Phone Number</label>
            <input
              type="text"
              className="form-control"
              id="phoneNumber"
              name="phoneNumber"
              value={currentParent.phoneNumber}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Email Address *</label>
            <input
              type="text"
              className="form-control"
              id="email"
              name="email"
              value={currentParent.email}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Address</label>
            <textarea
              type="text"
              className="form-control"
              id="address"
              name="address"
              value={currentParent.address}
              onChange={handleInputChange}
            />
          </div>
        </form>
        <div className="buttonRow">
          {updateMode ?
            <button
              type="submit"
              className="btn btn-primary"
              onClick={updateParent}
              disabled={saving}
            >
              {saving ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Updating...
                </>
              ) : (
                "Update"
              )}
            </button>
            :
            <button
              type="submit"
              className="btn btn-primary"
              onClick={addParent}
              disabled={saving}
            >
              {saving ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Saving...
                </>
              ) : (
                "Add"
              )}
            </button>
          }
          <button
            className="btn btn-secondary"
            onClick={() => history.goBack()}
          >
            Cancel
          </button>
          {
            updateMode && <button
              className="btn btn-danger"
              onClick={deleteParent}
              disabled={saving}
            >
              {saving ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Deleting...
                </>
              ) : (
                "Delete"
              )}
            </button>
          }
        </div>
        <p>{message}</p>
        <p className="errorText">{errorMessage}</p>


      </>
    );
  };

  return (
    <Container className="my-4">
      {/* MODERNIZED: Page is wrapped in a main Card for a modern look */}
      <Card className="h-100 shadow-sm">
        <Card.Header className="d-flex flex-column gap-2">
            <h3 className="mb-4">{updateMode ? "Update Parent" : "Add Parent"}</h3>
          </Card.Header>
        <Card.Body className="p-4">
          
          
          {loading ? <div className='loadingSpinner'><LoadingSpinner /></div> : renderBody()}
        </Card.Body>
      </Card>
      {renderStudents()}
    </Container>
  );

};

export default Parent;